(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('AjaxInterceptor', AjaxInterceptor);

    AjaxInterceptor.$inject = ['$q'];
    /* @ngInject */
    function AjaxInterceptor($q) {
        var service = {
            request: request
            //requestError: requestError,
            //response: response,
            //resposeError: responseError
        };
        return service;


        function request(config) {
            if (config) {
                if (config.url) {
                    if (config.url.indexOf('.html') === -1) {
                        if (config.headers) {
                            config.headers["X-CSFR-Token"] = encodeURIComponent($("body").attr("sp-request-verification-token"));
                        }
                    }
                }
            }
            
            return config || $q.when(config);
        }
        function requestError(rejection) {
            return $q.reject(rejection);
        }
        function response(response) {
            return response;
        }
        function responseError(rejection) {
            var deferred = $q.defer();
            return deferred.reject(rejection)
        }
    }
})();
